import {
  List,
  Datagrid,
  TextField,
  NumberField,
  BooleanField,
  EditButton,
  DeleteButton,
  DateField,
} from 'react-admin';

const CategoryList = () => (
  <List>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="name" label="Название" />
      <TextField source="slug" label="Слаг" />
      <TextField source="description" label="Описание" />
      <NumberField source="sortOrder" label="Порядок сортировки" />
      <BooleanField source="isActive" label="Активна" />
      <DateField source="createdAt" label="Создана" showTime />
      <DateField source="updatedAt" label="Обновлена" showTime />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);

export default CategoryList;






